<template>
    <div>
      <h1>QR Code Redirect</h1>
      <p>{{ qrData }}</p>
      <a :href="qrData">Click here to go to redirect</a>
    </div>
  </template>
  
  <script>
  export default {
    computed: {
      qrData() {
        console.log('QR Code Data:', decodeURIComponent(this.$route.query.data));
        return decodeURIComponent(this.$route.query.data); // Get the QR code data from the query
      },
    },
  };
  </script>